export function usesClientMods() {
  if (__MOBILE__) return false; // not implemented

  const win: any = window;
  return (
    // People who modify the Discord client usually use jQuery.
    // Explicitly check for the existence of Rambox.
    win.jQuery != null
    || win.$ != null
    // Explicitly check for the existence of BetterDiscord.
    || win.BetterDiscord != null
    || win.BdApi != null
    || win.rambox != null
  );
}
